<div class="grid__cell grid__cell--widget grid__cell--full widget__bag" [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget" id="pages-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Vaše formuláře</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
          <a [routerLink]="['add']" class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> formulář
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-forms-list [query]="query"></swb-forms-list>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
<router-outlet name="modal"></router-outlet>